export default __webpack_public_path__ + "static/media/redirect-link.a4e89827.svg";